export default "__VITE_ASSET__D5uc1m1T__"